import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function PowerFactorsReportDialog({ open, onClose, deviceId, deviceType, API_BASE }) {
  const { t } = useTranslation();
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [format, setFormat] = useState("xlsx");

  if (!open) return null;

  const handleDownload = () => {
    if (!start || !end) {
      alert(t('reports.dateError'));
      return;
    }

    const lang = localStorage.getItem("i18nextLng") || "tr";
    const url = `${API_BASE}/reports/export-power-factors?deviceId=${deviceId}&deviceType=${deviceType}&start=${start}&end=${end}&format=${format}&lang=${lang}`;
    window.open(url, "_blank");
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
        <h2 className="text-lg font-semibold mb-4 text-gray-800">
          {t('powerFactors.powerFactorsReport')}
        </h2>

        <div className="space-y-3">
          <div>
            <label className="text-sm text-gray-600">{t('reports.startDate')}</label>
            <input
              type="datetime-local"
              className="w-full border rounded-md px-3 py-2 text-sm"
              value={start}
              onChange={(e) => {
                setStart(e.target.value);
              }}
            />
          </div>
          <div>
            <label className="text-sm text-gray-600">{t('reports.endDate')}</label>
            <input
              type="datetime-local"
              className="w-full border rounded-md px-3 py-2 text-sm"
              value={end}
              onChange={(e) => {
                setEnd(e.target.value);
              }}
            />
          </div>
          <div>
            <label className="text-sm text-gray-600">{t('reports.format')}</label>
            <select
              value={format}
              onChange={(e) => setFormat(e.target.value)}
              className="w-full border rounded-md px-3 py-2 text-sm"
            >
              <option value="csv">CSV</option>
              <option value="xlsx">{t('reports.excel')}</option>
              <option value="png">{t('reports.chart')} (PNG)</option>
            </select>
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
          >
            {t('common.cancel')}
          </button>
          <button
            onClick={handleDownload}
            className="px-4 py-2 text-sm bg-sky-600 hover:bg-sky-700 text-white rounded-md"
          >
            {t('common.download')}
          </button>
        </div>
      </div>
    </div>
  );
}
